import { render, staticRenderFns } from "./SaveNotification.vue?vue&type=template&id=ba05f252&scoped=true&"
import script from "./SaveNotification.vue?vue&type=script&lang=js&"
export * from "./SaveNotification.vue?vue&type=script&lang=js&"
import style0 from "./SaveNotification.vue?vue&type=style&index=0&id=ba05f252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba05f252",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
